import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_i-pinned",
  "use": "svg_i-pinned-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"svg_i-pinned\"><path d=\"M6.333 9.667 2 14M3.332 6.324l6.129 6.128 1.131-1.131-.261-2.524 3.672-3.116-3.9-3.9-3.115 3.673-2.524-.262-1.132 1.132Z\" stroke=\"#fff\" stroke-width=\"1.882\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol